<p style="display: none;">
  auth-callback works!
</p>
